import { InsertionOrder, LineItem, PriceType } from 'modules/xandr/xandrApiTypes';

export const priceTypes = {
  [PriceType.ADDED]: {
    value: PriceType.ADDED,
    label: 'Added value',
  },
  [PriceType.CPM]: {
    value: PriceType.CPM,
    label: 'CPM',
  },
};

const formatLineItems = (items: LineItem[]) =>
  items.map((i) => {
    if (i.draftLI) {
      const { id, displayName, ...rest } = i.draftLI;

      return {
        id: -id,
        adGroupName: displayName,
        displayName,
        ...rest,
        synced: i.synced,
        enabled: i.enabled,
      };
    }

    return { ...i, adGroupName: i.displayName };
  });

export const formatInsertionOrders = (data: InsertionOrder[]) =>
  data.map((io) => {
    if (io.draftIO) {
      const { id, name, displayName, budgetCap } = io.draftIO;

      return {
        id: -id,
        name,
        displayName,
        budgetCap,
        key: -id,
        children: formatLineItems(io.lineItems || []),
        synced: io.synced,
        enabled: io.enabled,
      };
    }

    return {
      ...io,
      key: io.id,
      children: formatLineItems(io.lineItems || []),
    };
  });

export const countRows = (data: InsertionOrder[]) =>
  data.reduce((acc, cur) => acc + (cur.lineItems ? cur.lineItems?.length + 1 : 0), 0);

export const valueOrDashFormatter = (value: string) => (value ? value : '-');
export const priceTypeFormatter = (value: PriceType) => (value ? priceTypes[value].label : '-');
export const renderIfInsertionOrder = (value: string, data: InsertionOrder | LineItem) =>
  'children' in data ? value : '-';
export const renderIfLineItem = (value: string, data: InsertionOrder | LineItem) =>
  !('children' in data) ? value : '-';

const TABLE_OFFSET = 355;
const APPROX_ROW_SIZE = 80;
const rowsWithoutScroll = (height: number) => (height - TABLE_OFFSET) / APPROX_ROW_SIZE;

export const getYScroll = (rowCount: number, height: number) =>
  rowCount > rowsWithoutScroll(height) ? { y: height - TABLE_OFFSET } : {};
